import { registerSectionType } from "../../utils/sectionRegistry";
import { Section, renderImage, renderCtaButton, renderRichTextContent } from "../sectionHelpers";

registerSectionType({
  type: "filasDivididas",
  label: "Columna + imagen",
  layout: "split",
  previewBlocks: ["Texto", "Imagen"],
  getDefaults: () => ({ type: "filasDivididas", title: "", description: "", itemsText: "", draft_title: "", draft_description: "", draft_image: "", draft_position: "", textAlign: "left" }),
  editorFields: [
    { key: "title", label: "Titulo del bloque de texto" },
    { key: "description", label: "Descripcion del bloque de texto", input: "textarea" },
    { key: "image", label: "Imagen de la fila", placeholder: "https://..." },
  ],
  itemLabel: "fila",
  render: (section, index) => {
    const items = Array.isArray(section?.items) ? section.items : [];
    return (
      <Section section={section} keyName={`split-rows-${index}`}>
        <div className="dynamic-rows">
          {items.map((item, rowIdx) => (
            <article
              key={`${item?.title || "row"}-${rowIdx}`}
              className={`dynamic-row-item ${item?.reverse ? "dynamic-row-reverse" : ""}`}
            >
              {item?.image?.src ? (
                <div className="dynamic-row-media">
                  {renderImage(item.image.src, item.image.alt || item.title || "Imagen")}
                </div>
              ) : null}
              <div className="dynamic-row-content">
                {item?.title ? <h3>{item.title}</h3> : null}
                {item?.paragraphs?.length ? (
                  <div className="dynamic-rich-text">{renderRichTextContent(item.paragraphs)}</div>
                ) : item?.description ? <p>{item.description}</p> : null}
                {renderCtaButton(item?.button)}
              </div>
            </article>
          ))}
        </div>
      </Section>
    );
  },
});
